import bigHole from "../assets/Fallback/Big Hole/bigHole04.jpg";
import KimberleyBigHole from "../assets/WhatsApp Image 2024-11-04 at 07.43.27.jpeg";

export const createSlug = (title) =>
  title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const blogPosts = [
  {
    title: "Exploring the Big Hole: Kimberley's Iconic Landmark",
    description:
      "Discover the history, views, and visitor experiences that make the Big Hole one of Kimberley's essential stops.",
    content: [
      "The Big Hole remains one of Kimberley's strongest visitor signals: a landmark that carries the city's diamond story, mining heritage, and dramatic landscape in one place.",
      "A good visit is not only about seeing the edge of the excavation. Give yourself time for the museum, viewpoints, old-town details, and the surrounding heritage experience. It is the kind of stop that rewards slower looking.",
      "For first-time visitors, pair the Big Hole with nearby dining or a short city walk. That makes the day feel fuller without turning the itinerary into a rush.",
    ],
    image: KimberleyBigHole,
    author: "Tourism Expert",
    date: "November 5, 2024",
    tags: ["Heritage", "Big Hole", "Kimberley"],
    readTime: "4 min read",
  },
  {
    title: "A Visitor Guide to Kimberley Weekends",
    description:
      "Plan a richer city break with heritage stops, local food, family activities, and relaxed afternoon experiences.",
    content: [
      "A Kimberley weekend works best when it balances history, food, and unhurried local stops. Start with a landmark, leave space for a relaxed lunch, then use the afternoon for a gallery, museum, or nature experience.",
      "Families can keep the route simple by grouping nearby places together. Couples and solo visitors may prefer a slower pace with more time for cafes, photography, and local stories.",
      "The trick is to avoid overpacking the day. Kimberley has enough character that a few well-chosen stops can feel more memorable than a long checklist.",
    ],
    image: bigHole,
    author: "Local Guide",
    date: "November 1, 2024",
    tags: ["Travel", "Weekend", "Guide"],
    readTime: "5 min read",
  },
  {
    title: "Local Places Worth Slowing Down For",
    description:
      "Travel notes and practical tips for seeing more of Kimberley beyond the obvious stops.",
    content: [
      "Some of Kimberley's best moments are found between the major attractions: a quiet street, a good cup of coffee, a small gallery, or a local place with a story attached.",
      "Use the popular destinations as anchors, then add one or two nearby stops that give the day texture. This is where the city starts to feel personal rather than only historical.",
      "Visitors often remember the easy discoveries: where they paused, who they met, what they tasted, and the places that were not shouting for attention.",
    ],
    image: bigHole,
    author: "Travel Desk",
    date: "October 15, 2024",
    tags: ["Culture", "Local", "Stories"],
    readTime: "3 min read",
  },
  {
    title: "Discovering the Rich Heritage of Kimberley",
    description:
      "A short guide to the sites, museums, and stories that give the Diamond City its character.",
    content: [
      "Kimberley's heritage is layered: mining, architecture, public memory, art, and community life all sit close together. That makes the city especially rewarding for curious visitors.",
      "Museums and historic sites give structure to the story, but the surrounding streets and buildings help make it tangible. Look for routes that connect these places instead of treating each stop as separate.",
      "A heritage-focused day is strongest when it includes both official sites and ordinary city details. Together, they make Kimberley feel lived-in and distinctive.",
    ],
    image: KimberleyBigHole,
    author: "Local Guide",
    date: "November 10, 2024",
    tags: ["Heritage", "Museums", "Tourism"],
    readTime: "4 min read",
  },
  {
    title: "Beyond the Big Hole",
    description:
      "Explore hidden stops around the city, from cultural spaces to easy food and shopping routes.",
    content: [
      "The Big Hole may be Kimberley's headline, but the city has more to offer once visitors start moving beyond the obvious landmark.",
      "Build a day around contrast: history in the morning, a cafe or restaurant at midday, then art, shopping, or a nature stop later on. That rhythm keeps the experience fresh.",
      "For returning visitors, these smaller routes are often the reason to come back. They reveal the city in a more relaxed, human way.",
    ],
    image: bigHole,
    author: "Travel Enthusiast",
    date: "November 12, 2024",
    tags: ["Hidden Gems", "Food", "City"],
    readTime: "4 min read",
  },
].map((post) => ({
  ...post,
  slug: createSlug(post.title),
}));
